import { ModUpgrade } from '@components/arsenal/mods/ModUpgrade';
import { HoverMenu } from '@components/helpers/HoverMenu';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import * as Shared from '@shared/lib';
import { UserData } from '@stores';
import { useState } from 'react';

export interface EquippedModProps {
  mod: UserData['mods'][0];
  isOverCapacity: boolean;
  onRemove: () => void;
};

export function EquippedMod({ mod, isOverCapacity, onRemove }: EquippedModProps) {
  const [showUpgrade, setShowUpgrade] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Mods' });

  const data = Shared.modData.find(m => m.key === mod.key);
  if (!data) return null;

  const hoverItems = [
    { label: t('upgrade'), onClick: () => setShowUpgrade(true) },
    { label: t('remove'), onClick: () => onRemove() },
  ];

  const oC = isOverCapacity;

  return (
    <>
      <ModUpgrade onClose={() => setShowUpgrade(false)} open={showUpgrade} mod={mod} />

      <HoverMenu className={`${oC && 'mod-oc'} mod mod-${mod.rank} equipped-mod`} items={hoverItems} horizontal>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {oC && (
              <IconAlertTriangle className="text-red-500 mr-1 flashing" size={16} />
            )}

            <p className="mod-title">
              {t(`${mod.key}.name`)}
            </p>
          </div>

          <div className="mod-levels">
            {Array.from({ length: 4 + mod.rank * 2 }).map((_, i) => (
              <div className={`${mod.level >= i && 'is-active'} mod-level`} key={i} />
            ))}
          </div>
        </div>
      </HoverMenu>
    </>
  );
}